// 通用团队成员校验与清洗工具

/**
 * 校验团队成员：当 achievementType === 'team' 时，成员必填，且每人需填写姓名/身份/所属单位。
 * @param {string} achievementType
 * @param {Array} teamMembers
 * @returns {{ ok: boolean, message?: string }}
 */
export function ensureValidTeamMembers(achievementType, teamMembers) {
  if (achievementType !== 'team') return { ok: true }
  const list = Array.isArray(teamMembers) ? teamMembers : []
  if (list.length === 0) {
    return { ok: false, message: '团队成果需填写至少一位团队成员' }
  }
  for (let i = 0; i < list.length; i++) {
    const m = list[i] || {}
    const name = String(m.name || '').trim()
    const identity = String(m.identity || '').trim()
    const unit = String(m.unit || '').trim()
    if (!name) return { ok: false, message: `第${i + 1}位成员姓名未填写` }
    if (!identity) return { ok: false, message: `第${i + 1}位成员身份未选择` }
    if (!unit) return { ok: false, message: `第${i + 1}位成员所属单位未填写` }
  }
  return { ok: true }
}

/**
 * 统一团队成员对象结构，补全缺失字段并整理位次。
 * @param {Array} members
 * @returns {Array<{id:string,name:string,identity:string,unit:string,rank:number}>}
 */
export function sanitizeMembers(members = []) {
  const list = Array.isArray(members) ? members : []
  return list.map((m, idx) => ({
    id: m?.id ?? `${Date.now()}_${idx}`,
    name: String(m?.name ?? '').trim(),
    identity: String(m?.identity ?? '').trim(),
    unit: String(m?.unit ?? '').trim(),
    rank: Number(m?.rank ?? idx + 1) || idx + 1
  }))
}